import React from "react";
import { useNavigate } from "react-router-dom";
import { usePermissionPreview } from "../context/PermissionPreviewContext";
import "./PermissionPreviewBanner.css";

function PermissionPreviewBanner() {
	const { isPreviewing, previewLabel, previewPermissions, stopPreview } =
		usePermissionPreview();
	const navigate = useNavigate();

	if (!isPreviewing) return null;

	const count = previewPermissions.length;
	const countLabel = `${count} permission${count !== 1 ? "s" : ""}`;

	const handleExit = () => {
		const userId = stopPreview();
		if (userId != null) {
			navigate(`/users?userId=${userId}`);
		} else {
			navigate("/users");
		}
	};

	return (
		<div className="permission-preview-banner" role="status">
			<div className="permission-preview-banner-text">
				<strong>Permission preview</strong>
				<span>
					Viewing the UI as if you had{" "}
					{previewLabel ? (
						<>
							{" "}
							permissions of <em>{previewLabel}</em> ({countLabel}
							)
						</>
					) : (
						<> {countLabel}</>
					)}
					.
				</span>
			</div>
			<button
				type="button"
				className="btn btn-sm permission-preview-exit"
				onClick={handleExit}
			>
				Exit preview
			</button>
		</div>
	);
}

export default PermissionPreviewBanner;
